import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from '@/config/firebase';
import type { ApprovalData, RespondResult, SegmentResponse } from '../clientApprovalPage.types';

const REGION = 'us-central1';

function callables() {
    return getFunctions(app, REGION);
}

export async function getClientApproval(token: string): Promise<ApprovalData> {
    const call = httpsCallable<{ token: string }, ApprovalData>(callables(), 'getVacationClientApproval');
    const result = await call({ token });
    return result.data;
}

export async function respondClientApproval(
    token: string,
    segments: SegmentResponse[],
    note: string | null
): Promise<RespondResult> {
    const call = httpsCallable<
        { token: string; segments: SegmentResponse[]; note?: string },
        RespondResult
    >(callables(), 'respondVacationAsClient');
    const result = await call({ token, segments, ...(note !== null && { note }) });
    return result.data;
}
